import React from 'react';
import { IconProps } from '.';

const SvgBoxX = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.25 2.25h21.5v5.5h-1V13h-1.5V7.75H3.75v12.5H14v1.5H2.25v-14h-1v-5.5Zm20 1.5v2.5H2.75v-2.5h18.5Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M16.47 16.53 18.94 19l-2.47 2.47 1.06 1.06L20 20.06l2.47 2.47 1.06-1.06L21.06 19l2.47-2.47-1.06-1.06L20 17.94l-2.47-2.47-1.06 1.06Z'
      />
    </svg>
  );
};

export default SvgBoxX;
